import React from 'react';
import Noise from './reactbits/Noise/Noise';

const BackgroundFX = () => {
  return (
    <div className="nalexus-fx" aria-hidden="true">
      <div className="nalexus-orb orb-1" />
      <div className="nalexus-orb orb-2" />
      <div className="nalexus-orb orb-3" />
      <div className="nalexus-grid" />
      <Noise patternAlpha={12} patternRefreshInterval={3} />
    </div>
  );
};

export default BackgroundFX;


